import TrackElements from '@capsule/track-elements'
import type { TrackingEntry } from 'shared/assets/types/TrackingEntry'
import Carousel from 'shared/carousel/carousel'

export default class PeopleList {
	private peopleListWrapper: HTMLElement | null
	private peopleList: HTMLElement | null
	private peopleListItems: NodeListOf<HTMLElement> | null
	private isDesktop: boolean
	private hasOverflow: boolean

	constructor() {
		this.peopleListWrapper = document.querySelector('.peopleList')
		this.peopleList = this.peopleListWrapper?.querySelector('.peopleList-list') ?? null
		this.peopleListItems = this.peopleList?.querySelectorAll('.peopleList-listItem') ?? null
		this.isDesktop = window.matchMedia('(min-width: 1000px)').matches
		this.hasOverflow = (this.peopleList?.scrollWidth || 0) > (this.peopleList?.clientWidth || 0)
		this.initCarousel = this.initCarousel.bind(this)
	}

	init() {
		if (!this.peopleListWrapper) return

		if (this.isDesktop && this.hasOverflow) {
			this.initCarousel()
		}

		this.initTracking()
	}

	initCarousel() {
		if (this.peopleListWrapper) {
			const peopleCarousel = new Carousel({
				element: this.peopleListWrapper,
				itemsToScrollBy: 2
			})

			peopleCarousel.init()
		}
	}

	initTracking() {
		const trackElements = new TrackElements(this.trackingEntries)
		trackElements.init()
	}

	get trackingEntries() {
		if (!this.peopleListItems) return []

		const displayEntry: TrackingEntry = {
			element: this.peopleListWrapper,
			display: {
				event: 'navigation_display',
				navigation_type: 'about-people',
				navigation_label: 'connaissez-vous-bien'
			}
		}

		const clickEntries: TrackingEntry[] = [...this.peopleListItems].map((element) => ({
			element,
			click: {
				event: 'navigation_click',
				navigation_type: 'about-people',
				navigation_label: 'connaissez-vous-bien'
			}
		}))

		return [displayEntry, ...clickEntries]
	}
}
